import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
// import useWindowDimensions from '../theme/useWindowDimensions';
import LoginCard from '../ui/loginPage/LoginCard';
import FooterComp from './FooterComp';
import loginStyles from '../styles/loginStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
import Services from '../services/services';
import Loader from '../ui/Loader';
import toast, { Toaster } from 'react-hot-toast';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { loggedIn as logIn } from '../redux/userInfoSlice';
import { update, clearForm } from '../redux/loginSlice';
// import { landscapeMode } from '../theme/landscape';
import { isEmail } from '../regexFuncs';

import { setUserBrowserStorage } from '../constants';

const useStyles = makeStyles((theme) => loginStyles(theme));

const loginContFramer = {
  hidden: {
    x: '100vw',
  },
  visible: {
    x: 0,
    y: 0,
    opacity: 1,
    transition: {
      delay: 0.2,
      type: 'spring',
      stiffness: 60,
    },
  },
};

function LoginPage() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  // const { width } = useWindowDimensions();

  const dataFrom = location.state?.dataFrom;
  const pathCustom = location.state?.pathCustom;

  const loginForm = useSelector((state) => state.loginForm);

  const [loader, setLoader] = React.useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearForm({}));
    };
  }, []);

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      login_fun();
    }
  };

  const onChangeUser = (e) => {
    const value = (e.target.value || '').trim();
    const name = e.target.name;
    dispatch(
      update({ [name]: { error: false, helpertext: ' ', value: value } })
    );
  };

  // useEffect(() => {
  //   dispatch(
  //     update({ [name]: { error: false, helpertext: ' ', value: value } })
  //   );
  // }, []);

  const onClickRegister = () => {
    history.push('/signup');
  };

  const validation_fun = () => {
    let isFormValid = false;
    if (loginForm.username.value === '') {
      const name = 'username';
      isFormValid = false;
      dispatch(
        update({
          [name]: {
            error: true,
            helpertext: 'Email address is required',
            value: '',
          },
        })
      );
    } else if (!isEmail(loginForm.username.value)) {
      isFormValid = false;
      const name = 'username';
      dispatch(
        update({
          [name]: {
            error: true,
            helpertext: 'Email address is not valid',
            value: loginForm.username.value,
          },
        })
      );
    } else {
      isFormValid = true;
    }
    if (loginForm.password.value === '') {
      isFormValid = false;
      const name = 'password';
      dispatch(
        update({
          [name]: {
            error: true,
            helpertext: 'Password is required',
            value: '',
          },
        })
      );
    }
    return isFormValid;
  };

  const login_fun = () => {
    const isFormValid = validation_fun();

    if (isFormValid) {
      setLoader(true);
      Services.login_api(loginForm.username.value, loginForm.password.value)
        .then((loginResponce) => {
          setLoader(false);
          if (loginResponce.data.responseCode === 200) {
            const tokens = {
              accessToken: loginResponce.data.accessToken,
              refreshToken: loginResponce.data.refreshToken,
            };
            setUserBrowserStorage(
              'userDetails',
              JSON.stringify(loginResponce.data.userDetails)
            );
            setUserBrowserStorage('isLogin', 'true');
            setUserBrowserStorage('togetherTokens', JSON.stringify(tokens));

            dispatch(logIn({ userDetails: loginResponce.data.userDetails }));
            toast.dismiss();
            toast.success('Successfully logged In');
            if (dataFrom === 'share_handle' || dataFrom === 'invite_handle') {
              if (loginResponce.data.userDetails.firstLogin === true) {
                history.replace({
                  pathname: '/changepassword',
                  state: { pathCustom: pathCustom },
                });
                return;
              }

              history.replace({
                pathname: pathCustom,
              });
              return;
            } else {
              // if (loginResponce.data.userDetails.firstLogin === true) {
              //   history.replace({
              //     pathname: '/changepassword',
              //   });
              //   return;
              // } else if (!loginResponce.data.userDetails.lastName) {
              //   history.replace({
              //     pathname: '/myprofile',
              //   });
              //   return;
              // }
              history.replace({
                pathname: '/',
              });
              return;
            }
          } else if (
            loginResponce.data.responseCode === 404 ||
            loginResponce.data.responseCode === 401
          ) {
            // clearAllBrowserStorage();
            toast.dismiss();
            toast.error(loginResponce.data.details, { duration: 4000 });
          } else {
            // clearAllBrowserStorage();
            toast.dismiss();
            toast.error('Login failed', { duration: 4000 });
          }
        })
        .catch((error) => {
          setLoader(false);
        });
    }
  };

  return (
    <Container maxWidth={false} className={classes.loginPageCont}>
      <Grid
        container
        component='div'
        justify='center'
        alignItems='center'
        style={{ flex: 1 }}
      >
        <Grid item sm={2} xs={false}></Grid>
        <Grid
          item
          container
          xs={12}
          sm={8}
          justify='center'
          alignItems='center'
          component={motion.div}
          variants={loginContFramer}
          initial='hidden'
          animate='visible'
        >
          <Grid
            container
            item
            xs={12}
            component='div'
            className={classes.mainContainer}
          >
            <LoginCard
              card={classes.card}
              imgGrid={classes.imgGrid}
              imageCls={classes.imageCls}
              title={classes.title}
              form={classes.form}
              inputField={classes.inputField}
              usernameHelptext={loginForm.username.helpertext}
              usernameError={loginForm.username.error}
              usernameValue={loginForm.username.value}
              handleEnter={handleEnter}
              onChangeUser={onChangeUser}
              frgtPswd={classes.frgtPswd}
              passwordHelptext={loginForm.password.helpertext}
              passwordError={loginForm.password.error}
              passwordValue={loginForm.password.value}
              termsContainer={classes.termsContainer}
              policyLink={classes.policyLink}
              termsText={classes.termsText}
              signinBtn={classes.signinBtn}
              login_fun={login_fun}
              optionalContainer={classes.optionalContainer}
              captionText={classes.captionText}
              registerBtn={classes.registerBtn}
              onClickRegister={onClickRegister}
              formGridCont={classes.formGridCont}
              tagLine={classes.tagLine}
            />
          </Grid>
        </Grid>
        <Grid item sm={2} xs={false}></Grid>
        <Grid
          item
          container
          component='div'
          style={{ position: 'absolute', bottom: 0, zIndex: 50000 }}
        >
          <Grid item sm={2} xs={false}></Grid>
          <Grid item sm={8}>
            <CookieConsent
              location='bottom'
              buttonText='I understand'
              cookieName='cookiePermissionYes'
              style={{ background: '#2B373B' }}
              buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
              onAccept={() => {}}
              onDecline={() => {
                const cookieKeysArr = Object.keys(Cookies.getJSON());
                cookieKeysArr.forEach((each) => Cookies.remove(each));
              }}
              expires={365}
              enableDeclineButton
            >
              This website uses cookies to enhance the user experience.
            </CookieConsent>
          </Grid>
          <Grid
            item
            sm={2}
            component='div'
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            {/* <Typography
              variant="caption"
              style={{ color: '#fff', marginRight: 3, fontSize: 9 }}
            >
              V.1.1.7.4
            </Typography> */}
          </Grid>
        </Grid>
      </Grid>
      <FooterComp />

      <Toaster position='top-center'></Toaster>
      <Loader open={loader} />
    </Container>
  );
}

export default LoginPage;
